import React from 'react';
import moment from 'moment';
import 'moment/locale/uk'
import { Preloader } from 'MWComponents';
import {
  URL_NEWS
} from '../variables';

export default function template() {
    const {navigate} = this.props;
    const  {news, isMobile} = this.state,
        newsList = news.map(article => {
          return (
              <div key={article.id} className="news-column">
                 <div className="news-item" onClick={e => navigate(`/news/${article.id}`, e)} onKeyDown={(e) => e.key === 'Enter' && navigate(`/news/${article.id}`, e)} tabIndex="0">
                  <time className="news-date" dateTime={article.date}>{moment(article.date).locale('uk').format("DD MMMM YYYY")} {this.l10n('YYYY')}</time>
                  <h3 className="news-text">{article.title_ua}</h3>
                 </div>
              </div>
          );
      });

    return news.length > 0 ? (
      <div className="news">
        <div className="container">
          <div className="news__body">
            <div className="news__top top-news">
              <h2 className="top-news__title">{this.l10n('NEWS_NEW_TITLE')}</h2>
              {!isMobile && <div className="top-news__all" onClick={e => navigate(URL_NEWS, e)} onKeyDown={(e) => e.key === 'Enter' && navigate(URL_NEWS, e)} tabIndex="0">{this.l10n('NEWS_NEW_ALL')}</div>}
            </div>
            <div className="news__row">{newsList}</div>
            {isMobile && <div className="top-news__all mobile" onClick={e => navigate(URL_NEWS, e)} onKeyDown={(e) => e.key === 'Enter' && navigate(URL_NEWS, e)} tabIndex="0">{this.l10n('NEWS_NEW_ALL')}</div>}
          </div>
        </div>
      </div>
    ) : (
      <Preloader />
    );
}